module.exports = __webpack_public_path__ + "img/Diga.a6b54f16.png";